import React from "react";
import "./ChessBoards.css";
import RookGame from "./ChessGame/RookGame/RookGame";
import { renderStatementWithKaTeX } from "../../../../../Functions/WriteLaTex";
const ChessBoards = () => {
  return (
    <div className="Game Chessboards-Container">
      <div className="discription">
        <h1>♟️ Chess Related Problems :</h1>

        <h2>- Problems Statement -</h2>
      </div>
      <div className="Jeux">
        <h3>♜ Rook Race :</h3>
        <div className="ChessStatement">
          {renderStatementWithKaTeX(
            "On a regular chessboard a rook is placed on $a1$ (bottom-left corner). Players $A$ and $B$ take alternating turns by moving the rook upwards or to the right by any distance (no left or down movements allowed). Player $A$ makes the first move, and the winner is whoever first reaches $h8$ (top-right corner). Is there a winning strategy for any of the players?"
          )}
        </div>
        <RookGame />
      </div>
    </div>
  );
};

export default ChessBoards;
